import { Link } from 'react-router-dom';

const highlights = [
  { icon: 'ri-book-2-line', title: '海量书库', desc: '玄幻、言情、历史、都市、仙侠多题材覆盖' },
  { icon: 'ri-refresh-line', title: '章节更新', desc: '追变更省心，最新章节及时呈现' },
  { icon: 'ri-eye-line', title: '舒适阅读', desc: '字号调节与护眼模式，久读不累' },
  { icon: 'ri-heart-3-line', title: '一键收藏', desc: '喜欢的书放入书架，随时继续' },
];

export default function SiteIntro() {
  return (
    <section className="bg-gradient-to-br from-primary-50 via-background-50 to-accent-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于美丽的小蜜桃
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            美丽的小蜜桃是一个专注于网络小说在线阅读与章节更新的平台。我们希望能成为你书签里的那家小店，
            无论你是偏爱热血玄幻、细腻言情，还是沉醉于历史长河与仙侠秘境，都能在这里找到属于你的那本书。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((h) => (
            <div
              key={h.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 text-center"
            >
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${h.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{h.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{h.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}